<template>
  <global-dialog-card
    v-model="dialog"
    :max-width="1200"
    :title="$t('select_restaurant')"
    hide-actions
  >
    <!-- Loading State -->
    <empty-state
      v-if="loading"
      :title="$t('loading_restaurants')"
      :loading="true"
    />

    <!-- Error State -->
    <empty-state
      v-else-if="error"
      icon="mdi-alert-circle"
      :title="$t('error_loading_restaurants')"
    >
      <v-btn color="primary" outlined @click="fetchRestaurants()">
        {{ $t("retry") }}
      </v-btn>
    </empty-state>

    <!-- Content State -->
    <v-row
      v-else-if="chooseNewRestoran.length"
      class="align-content-center justify-content-center mt-4"
    >
      <v-col cols="12" md="6" lg="4" v-for="res in chooseNewRestoran" :key="res.id">
        <div
          style="
            box-shadow: 0 1px 14px 2px rgba(0, 0, 0, 0.12);
            border-radius: 7px;
            height: 230px;
            position: relative;
          "
          :class="{ 'pointer-events-none': selecting }"
        >
          <div
            v-if="selecting && selectedRestaurantId === res.id"
            class="d-flex align-center justify-center"
            style="
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: rgba(255, 255, 255, 0.8);
              z-index: 10;
              border-radius: 7px;
            "
          >
            <v-progress-circular
              indeterminate
              color="primary"
              size="32"
            ></v-progress-circular>
          </div>
          <img
            :src="
              res.settings
                ? conf.apiUrlBase + '/gallery/' + res.id + '/' + res.settings.header
                : backupImage
            "
            alt="Logo"
            @error="onImageError"
            @click="selectNewRes(res)"
            class="card-img-top"
            width="100%"
            height="80%"
            style="
              cursor: pointer;
              border-top-left-radius: 10px;
              border-top-right-radius: 10px;
            "
          />
          <div class="card-body">
            <h5 class="card-title">{{ toLatin(res.name) }}</h5>
            <p style="font-size: 11px" class="card-text mb-0 font-weight-bold">
              <span>
                <v-icon small class="mr-2">mdi-edit_location</v-icon>
                {{ res.city ? toLatin(res.city.name) : "" }}
              </span>
            </p>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Empty State -->
    <empty-state
      v-else
      icon="mdi-store-off"
      :title="$t('no_restaurants_available')"
    />
  </global-dialog-card>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import hasModel from "@/mixins/hasModel";
import hasSnackbar from "@/mixins/hasSnackbar";
import conf from "@/config";
import userService from "@/services/user";
import restaurantService from "@/services/restaurant";
import EmptyState from "@/components/global/EmptyState.vue";

export default {
  name: "CompanyMenuNewRestaurantDialog",
  mixins: [hasModel, hasSnackbar],
  components: {
    EmptyState,
  },
  computed: {
    ...mapState("companyMenu", ["dialogs"]),
    dialog: {
      get() {
        return this.dialogs.newRestaurant;
      },
      set(val) {
        this.setDialog({ dialog: "newRestaurant", value: val });
      },
    },
  },
  data() {
    return {
      chooseNewRestoran: [],
      loading: false,
      error: false,
      selecting: false,
      selectedRestaurantId: null,
      conf,
      backupImage: "https://app.restorani.bitlab.host/gallery/no-image-restaurant.jpg",
    };
  },
  methods: {
    ...mapMutations("companyMenu", ["setDialog"]),
    fetchRestaurants() {
      this.loading = true;
      this.error = false;
      this.chooseNewRestoran = [];

      restaurantService
        .getAllRestaurantsPublic()
        .then(({ data }) => {
          this.chooseNewRestoran = data.data;
        })
        .catch((error) => {
          console.error("Error loading restaurants:", error);
          this.error = true;
          this.showErrorSnackbar(this.$t("error_loading_restaurants"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectNewRes(res) {
      if (this.selecting) return; // Prevent multiple simultaneous selections

      this.selecting = true;
      this.selectedRestaurantId = res.id;

      const userId = this.$store.state.user.user?.id;
      const restaurantId = res.id;

      userService
        .chooseRestaurant(userId, restaurantId)
        .then(({ data }) => {
          if (data.data) {
            this.showSuccessSnackbar(this.$t("restaurant_selected"));
            this.$emit("restaurantChoosen");
            this.dialog = false;
          }
        })
        .catch((error) => {
          console.error("Error selecting restaurant:", error);
          this.showErrorSnackbar(this.$t("error_selecting_restaurant"));
        })
        .finally(() => {
          this.selecting = false;
          this.selectedRestaurantId = null;
        });
    },
    onImageError(event) {
      event.target.src = this.backupImage;
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.fetchRestaurants();
      }
    },
  },
};
</script>
